import { render } from "./PlanRegister.vue?vue&type=template&id=6b98a526"
import script from "./PlanRegister.vue?vue&type=script&lang=js"
export * from "./PlanRegister.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__